import { MapPin } from "lucide-react";
import { Reveal } from "./Reveal";
import { GALLERY } from "@/lib/site";

export const Gallery = () => (
  <section id="gallery" className="relative py-24 lg:py-36 px-6 lg:px-12 bg-[#0a0c10]" data-testid="gallery-section">
    <div className="max-w-[1400px] mx-auto">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.4em] text-orange-500 mb-4">Portfolio</p>
        <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl leading-[0.9] text-white uppercase">
          Proof of <span className="text-orange-500">Work</span>
        </h2>
        <p className="mt-4 font-mono text-xs sm:text-sm uppercase tracking-[0.2em] text-slate-400">
          Recent construction & renovation projects across the region
        </p>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 auto-rows-[240px] gap-3 grid-flow-dense">
        {GALLERY.map((item, i) => (
          <Reveal key={item.testid} delay={i * 0.06} className={item.span}>
            <figure
              data-testid={item.testid}
              className="group relative h-full w-full overflow-hidden border border-white/10 hover:border-orange-500/60 transition-colors duration-300"
            >
              <img
                src={item.image}
                alt={item.title}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0c0e12]/95 via-[#0c0e12]/20 to-transparent opacity-80 group-hover:opacity-100 transition-opacity duration-300" />
              <figcaption className="absolute inset-x-0 bottom-0 p-5">
                <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-orange-500">{item.category}</p>
                <h3 className="mt-1 font-display text-xl sm:text-2xl tracking-wide text-white uppercase leading-tight">
                  {item.title}
                </h3>
                <p className="mt-1 inline-flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-[0.2em] text-slate-400">
                  <MapPin size={11} className="text-orange-500" />
                  {item.location}
                </p>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
